import { gql } from "@apollo/client";

export const UPDATE_ADMIN_PROFILE = gql`
  mutation updateSchoolAdmin($input: updateAdminInput!) {
    updateSchoolAdminDetails(input: $input) {
      message
    }
  }
`;
